(function () {
  class PotBonus extends PIXI.Container {
    constructor() {
      super();

      this.chosenFireballs = [];
      this._recoveryHandle = undefined;
      this._recoveryChosenFireballs = [];

      this._isReplay = false;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "8bof:PotBonusStartEvent",
        this.onPotBonusStartEvent.bind(this)
      );
      messageBus.subscribe(
        "common:RecoverGameListener",
        this.recoverGame.bind(this)
      );
    }

    onGameConfigEvent() {
      this.potBonusBackground = resourceManager.get(
        "baseGameBackground:landscapeBackground:mountainsFreeSpins"
      );
      this.potBonusBackground.visible = false;
      this.potBonusPortraitBackground = resourceManager.get(
        "baseGameBackground:portraitBackground:mountainsFreeSpins"
      );
      this.potBonusPortraitBackground.visible = false;

      this._elementsToFadeOut = [
        resourceManager.get("slotContainer:reelContainer"),
        resourceManager.get("slotContainer:reelFrame"),
        resourceManager.get("slotContainer:frameP1"),
        resourceManager.get("baseGameLogo"),
      ];
      this._fireballIntro = resourceManager.get(
        "potBonus:potBonusContainer:potBonusIntroAnim"
      );
      this._fireballIntro.visible = false;

      this._matchText = resourceManager.get(
        "potBonus:potBonusContainer:match3ToWin"
      );
      this._matchText.visible = false;

      this._winningsPanel = resourceManager.get(
        "potBonus:potBonusContainer:winningsBox"
      );
      this._winningsPanel.visible = false;
      this._winningsValue = resourceManager.get(
        "potBonus:potBonusContainer:winningsBox:value"
      );

      this._greenTint = 0x0fde0c;
      this._pinkTint = 0xc954ee;

      this._fireballs = [];
      const self = this;
      for (let reel = 0; reel < 4; ++reel) {
        for (let row = 0; row < gameData.numRows; ++row) {
          const id = reel * gameData.numRows + row;
          const shockwave = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:shockwave"
          );
          shockwave.blendMode = PIXI.BLEND_MODES.ADD;
          shockwave.gotoAndStop(0);
          shockwave.visible = false;
          shockwave.onComplete = function () {
            shockwave.visible = false;
          };
          const blueFireball = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:blueFireball"
          );
          blueFireball.visible = false;
          const redFireball = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:redFireball"
          );
          redFireball.visible = false;
          const greenFireball = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:greenFireball"
          );
          greenFireball.visible = false;
          const magentaFireball = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:magentaFireball"
          );
          magentaFireball.visible = false;

          const miniText = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:miniText"
          );
          miniText.visible = false;
          const minorText = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:minorText"
          );
          minorText.visible = false;
          const majorText = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:majorText"
          );
          majorText.visible = false;
          const megaText = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:megaText"
          );
          megaText.visible = false;

          const fireball = resourceManager.get(
            "potBonus:potBonusContainer:potBonusIntroAnim:potBonusFireball_" +
              reel +
              "_" +
              row +
              ":fireball:fireballContainer:fireball:fireball"
          );
          const fireballObj = {
            fireball,
            shockwave,
            colouredFireballs: {
              blueFireball,
              redFireball,
              greenFireball,
              magentaFireball,
            },
            texts: { miniText, minorText, majorText, megaText },
            picked: function () {
              fireball.interactive = false;
              fireball.mousedown = fireball.touchstart = function () {};
              self.playPickSound();
              self.toggleFireballTouch(false);
              self.chosenFireballs.push({ reel, row, id });
              gdk.saveClientState(
                { PotBonus: { chosenFireballs: self.chosenFireballs } },
                function () {
                  self.animateFireball(
                    fireballObj,
                    self._picks[self._picksIndex++],
                    id
                  );
                }
              );
            },
          };
          fireball.mousedown = fireball.touchstart = function () {
            fireballObj.picked();
          };
          this._fireballs.push(fireballObj);
        }
      }

      this._celebrationFireballsRed = [
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsRed:potBonusCelebrationFireball0:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_red",
            "potBonus:potBonusContainer:particlesContainer0",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsRed:potBonusCelebrationFireball1:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_red",
            "potBonus:potBonusContainer:particlesContainer1",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsRed:potBonusCelebrationFireball2:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_red",
            "potBonus:potBonusContainer:particlesContainer2",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsRed:potBonusCelebrationFireball3:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_red",
            "potBonus:potBonusContainer:particlesContainer3",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsRed:potBonusCelebrationFireball4:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_red",
            "potBonus:potBonusContainer:particlesContainer4",
            0,
            0,
            false
          ),
        },
      ];
      this._celebrationFireballsBlue = [
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsBlue:potBonusCelebrationFireball0:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_blue",
            "potBonus:potBonusContainer:particlesContainer0",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsBlue:potBonusCelebrationFireball1:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_blue",
            "potBonus:potBonusContainer:particlesContainer1",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsBlue:potBonusCelebrationFireball2:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_blue",
            "potBonus:potBonusContainer:particlesContainer2",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsBlue:potBonusCelebrationFireball3:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_blue",
            "potBonus:potBonusContainer:particlesContainer3",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsBlue:potBonusCelebrationFireball4:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_blue",
            "potBonus:potBonusContainer:particlesContainer4",
            0,
            0,
            false
          ),
        },
      ];
      this._celebrationFireballsGreen = [
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsGreen:potBonusCelebrationFireball0:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_green",
            "potBonus:potBonusContainer:particlesContainer0",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsGreen:potBonusCelebrationFireball1:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_green",
            "potBonus:potBonusContainer:particlesContainer1",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsGreen:potBonusCelebrationFireball2:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_green",
            "potBonus:potBonusContainer:particlesContainer2",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsGreen:potBonusCelebrationFireball3:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_green",
            "potBonus:potBonusContainer:particlesContainer3",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsGreen:potBonusCelebrationFireball4:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_green",
            "potBonus:potBonusContainer:particlesContainer4",
            0,
            0,
            false
          ),
        },
      ];
      this._celebrationFireballsPurple = [
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsPurple:potBonusCelebrationFireball0:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_purple",
            "potBonus:potBonusContainer:particlesContainer0",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsPurple:potBonusCelebrationFireball1:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_purple",
            "potBonus:potBonusContainer:particlesContainer1",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsPurple:potBonusCelebrationFireball2:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_purple",
            "potBonus:potBonusContainer:particlesContainer2",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsPurple:potBonusCelebrationFireball3:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_purple",
            "potBonus:potBonusContainer:particlesContainer3",
            0,
            0,
            false
          ),
        },
        {
          fireball: resourceManager.get(
            "potBonus:potBonusContainer:potBonusCelebrationFireballsPurple:potBonusCelebrationFireball4:fireball"
          ),
          emitter: particleManager.createEmitter(
            "potBonus_purple",
            "potBonus:potBonusContainer:particlesContainer4",
            0,
            0,
            false
          ),
        },
      ];

      this._celebrationFireballsRed.forEach((fireball) => {
        fireball.emitter.particleEmitter.emit = false;
      });
      this._celebrationFireballsBlue.forEach((fireball) => {
        fireball.emitter.particleEmitter.emit = false;
      });
      this._celebrationFireballsGreen.forEach((fireball) => {
        fireball.emitter.particleEmitter.emit = false;
      });
      this._celebrationFireballsPurple.forEach((fireball) => {
        fireball.emitter.particleEmitter.emit = false;
      });

      this._potValueTexts = [
        resourceManager.get("potContainer:mini:value"),
        resourceManager.get("potContainer:minor:value"),
        resourceManager.get("potContainer:major:value"),
        resourceManager.get("potContainer:mega:value"),
      ];
    }

    onPotBonusStartEvent(task) {
      resourceManager.getController("inputOverlord").setState("potBonus");
      gameController.cancelWildTimers();
      gameController.symbolLandAnimator.skip();
      gameController.wildLandAnimator.skip();
      gameController.symbolLandAnimator.skip();
      gameController.skip();

      gameController.cancelAutoplay();

      this.chosenFireballs = [];

      this._fireballs.forEach(function (data) {
        data.fireball.mousedown = data.fireball.touchstart = function () {
          data.picked();
        };
      });

      if (this._isReplay) {
        if (
          this._recoveryChosenFireballs.length !== task.data.sequence.length
        ) {
          this.autoPick(
            task.data.sequence.length - this._recoveryChosenFireballs.length
          );
        }
        this._isReplay = false;
      }

      this._winningsValue.setText(0);
      this._winningsValue.visible = false;
      this._picks = task.data.sequence;
      this._picksIndex = 0;
      this._winningPot = task.data.potWon;
      this._potBonusTask = task;
      task.join();

      const self = this;

      timerManager.addTimer(
        1600,
        function () {},
        function () {
          game.thunderAnim.play(0);
          soundManager.play("thunder");
          soundManager.play("lightningPunch");
        }
      );

      timerManager.addTimer(
        2600,
        function () {},
        function () {
          game.lightningFlashAnim.play(0);
          soundManager.play("lightning3");
          self.start();
        }
      );
    }

    autoPick(numberRequired) {
      let ids = 0;

      for (let i = 0; i < 12; i++) {
        const found = this._recoveryChosenFireballs.find(
          (element) => element.id === i
        );

        if (found === undefined) {
          ids++;
          this._recoveryChosenFireballs.unshift({ id: i });
        }

        if (ids === numberRequired) {
          break;
        }
      }
    }

    fireCelebratoryFireballs(fireballs, callback) {
      this._celebrationFireballIndex = 0;
      this._previousFireballIndex = -1;
      this._celebrationOn = true;
      const self = this;

      timerManager.addTimeout(3500, function () {
        self._celebrationOn = false;
      });

      gameData.musicManager.fadeOutAllMusic(0.3);
      soundManager.play("potBonusWin");

      this.fireNextCelebratoryFireball(fireballs, callback);
    }

    explodeCelebratoryFireball(fireballs, index) {
      fireballs[index].fireball.visible = false;
      fireballs[index].emitter.particleEmitter.emit = true;
      fireballs[index].emitter.visible = true;

      let potValueText = undefined;
      switch (this._winningPot) {
        case "Mini": {
          potValueText = this._potValueTexts[0];
          break;
        }
        case "Minor": {
          potValueText = this._potValueTexts[1];
          break;
        }
        case "Major": {
          potValueText = this._potValueTexts[2];
          break;
        }
        case "Mega": {
          potValueText = this._potValueTexts[3];
          break;
        }
      }

      timerManager.addTimer(
        250,
        function (progress) {
          const scale = 1 + Math.abs(Math.sin(Math.PI * progress)) * 0.25;
          potValueText.scale.set(scale, scale);
        },
        function () {
          potValueText.scale.set(1, 1);
        }
      );
    }

    fireNextCelebratoryFireball(fireballs, callback) {
      const self = this;

      let currentIndex = -1;

      do {
        currentIndex = Math.floor(Math.random() * fireballs.length);
      } while (currentIndex === this._previousFireballIndex);

      this._previousFireballIndex = currentIndex;

      fireballs[currentIndex].fireball.animate(function () {
        self.explodeCelebratoryFireball(fireballs, currentIndex);
      });

      ++self._celebrationFireballIndex;

      if (self._celebrationOn) {
        timerManager.addTimeout(500, function () {
          self.fireNextCelebratoryFireball(fireballs, callback);
        });
      } else {
        callback();
      }
    }

    start() {
      if (gameController.inFreeSpins) {
        soundManager.stop("FreespinsMusic");
      }

      soundManager.play("potIntro");

      this._matchText.visible = true;

      const self = this;
      timerManager.addTimer(
        50,
        function (progress) {
          self._elementsToFadeOut.forEach(function (element) {
            element.alpha = 1 - progress;
          });
        },
        function () {
          self._elementsToFadeOut.forEach(function (element) {
            element.alpha = 0;
            element.visible = false;
          });

          self._fireballs.forEach(function (fireball) {
            fireball.fireball.gotoAndPlay(0);
          });
          self._fireballIntro.visible = true;
          self._fireballIntro.animate(function () {
            self.pickNextFireball();
          });
        }
      );
    }

    pickNextFireball() {
      if (
        this._recoveryChosenFireballs &&
        this._recoveryChosenFireballs.length > 0
      ) {
        const pickedFireball = this._recoveryChosenFireballs.pop();

        this._fireballs[pickedFireball.id].picked();
      } else {
        if (this._recoveryHandle) {
          this._recoveryHandle.leave();
          this._recoveryHandle = undefined;
        }
        this.toggleFireballTouch(true);
      }
    }

    playPickSound() {
      soundManager.play("thunderballExplode");
      soundManager.play("electricBuzz");
    }

    toggleFireballTouch(on) {
      this._fireballs.forEach(function (fireball) {
        fireball.fireball.interactive = on;
      });
    }

    animateFireball(fireball, potPicked) {
      let colouredFireball = undefined;
      let text = undefined;
      switch (potPicked) {
        case "Mini": {
          colouredFireball = fireball.colouredFireballs.greenFireball;
          colouredFireball.tint = this._greenTint;
          text = fireball.texts.miniText;
          break;
        }
        case "Minor": {
          colouredFireball = fireball.colouredFireballs.blueFireball;
          text = fireball.texts.minorText;
          break;
        }
        case "Major": {
          colouredFireball = fireball.colouredFireballs.magentaFireball;
          colouredFireball.tint = this._pinkTint;
          text = fireball.texts.majorText;
          break;
        }
        case "Mega": {
          colouredFireball = fireball.colouredFireballs.redFireball;
          text = fireball.texts.megaText;
          break;
        }
      }

      colouredFireball.visible = true;
      colouredFireball.alpha = 0;

      text.visible = true;
      text.alpha = 0;

      timerManager.addTimeout(250, function () {
        fireball.shockwave.gotoAndPlay(0);
        fireball.shockwave.visible = true;
      });

      const self = this;
      timerManager.addTimer(
        300,
        function (progress) {
          const scale = 0.85 + 0.15 * (1 - progress);
          const scaleColoured = 0.85 + 0.15 * progress;
          fireball.fireball.alpha = 1 - progress;
          fireball.fireball.scale.set(scale, scale);
          colouredFireball.alpha = progress;
          colouredFireball.scale.set(scaleColoured, scaleColoured);
          text.alpha = progress;
        },
        function () {
          fireball.fireball.alpha = 0;
          fireball.fireball.visible = false;
          fireball.fireball.scale.set(1, 1);
          colouredFireball.scale.set(1, 1);
          colouredFireball.alpha = 1;
          text.alpha = 1;
          timerManager.addTimer(
            300,
            function (progress) {
              const scale = InterpolationHelper.interpolateSine(
                1,
                1.25,
                progress
              );
              text.scale.set(scale, scale);
            },
            function () {
              text.scale.set(1, 1);
              if (self._picksIndex < self._picks.length) {
                self.pickNextFireball();
              } else {
                self.endFeature();
              }
            }
          );
        }
      );
    }

    doCelebration(callback) {
      soundManager.play("potWon");

      switch (this._winningPot) {
        case "Mini": {
          this.fireCelebratoryFireballs(
            this._celebrationFireballsGreen,
            callback
          );
          break;
        }
        case "Minor": {
          this.fireCelebratoryFireballs(
            this._celebrationFireballsBlue,
            callback
          );
          break;
        }
        case "Major": {
          this.fireCelebratoryFireballs(
            this._celebrationFireballsPurple,
            callback
          );
          break;
        }
        case "Mega": {
          this.fireCelebratoryFireballs(
            this._celebrationFireballsRed,
            callback
          );
          break;
        }
        default: {
          //belt and braces
          callback();
        }
      }
    }

    endFeature() {
      const self = this;

      this._pulseCount = 11;
      this.pulseWinningFireballs();

      soundManager.play("winBoxEnter");

      this._matchText.visible = false;
      this._winningsPanel.visible = true;
      this._winningsPanel.alpha = 0;
      timerManager.addTimer(
        1000,
        function (progress) {
          self._winningsPanel.alpha = progress;
        },
        function () {
          self._winningsPanel.alpha = 1;

          let potValueText = undefined;
          switch (self._winningPot) {
            case "Mini": {
              potValueText = self._potValueTexts[0];
              break;
            }
            case "Minor": {
              potValueText = self._potValueTexts[1];
              break;
            }
            case "Major": {
              potValueText = self._potValueTexts[2];
              break;
            }
            case "Mega": {
              potValueText = self._potValueTexts[3];
              break;
            }
          }
          self._winningsValue.visible = true;

          gameData.musicManager.startPotBonusCountUp();

          timerManager.addTimer(
            2000,
            function (progress) {
              const val = self._potBonusTask.data.winAmount * progress;
              self._winningsValue.setText(gdk.formatCurrency(val));

              const scale =
                1 + Math.abs(Math.sin(Math.PI * 3 * progress)) * 0.25;
              potValueText.scale.set(scale, scale);
            },
            function () {
              self._winningsValue.setText(
                gdk.formatCurrency(self._potBonusTask.data.winAmount)
              );
              potValueText.scale.set(1, 1);

              timerManager.addTimer(
                500,
                function (progress) {
                  let newScale =
                    1 + Math.abs(Math.sin(Math.PI * progress) * 0.25);
                  self._winningsValue.scale.set(newScale, newScale);
                },
                function () {
                  self._winningsValue.scale.set(1, 1);
                }
              );

              gameData.winningsMeter.add(self._potBonusTask.data.winAmount);

              gameData.musicManager.endPotBonusCountUp();

              self.doCelebration(function () {
                timerManager.addTimeout(2000, function () {
                  self.returnToBaseGame();
                });
              });
            }
          );
        }
      );
    }

    pulseWinningFireballs() {
      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          const scale = InterpolationHelper.interpolateSine(1, 1.25, progress);
          self._fireballs.forEach(function (fireball) {
            switch (self._winningPot) {
              case "Mini": {
                if (fireball.colouredFireballs.greenFireball.visible) {
                  fireball.colouredFireballs.greenFireball.scale.set(
                    scale,
                    scale
                  );
                  fireball.texts.miniText.scale.set(scale, scale);
                }
                break;
              }
              case "Minor": {
                if (fireball.colouredFireballs.blueFireball.visible) {
                  fireball.colouredFireballs.blueFireball.scale.set(
                    scale,
                    scale
                  );
                  fireball.texts.minorText.scale.set(scale, scale);
                }
                break;
              }
              case "Major": {
                if (fireball.colouredFireballs.magentaFireball.visible) {
                  fireball.colouredFireballs.magentaFireball.scale.set(
                    scale,
                    scale
                  );
                  fireball.texts.majorText.scale.set(scale, scale);
                }
                break;
              }
              case "Mega": {
                if (fireball.colouredFireballs.redFireball.visible) {
                  fireball.colouredFireballs.redFireball.scale.set(
                    scale,
                    scale
                  );
                  fireball.texts.megaText.scale.set(scale, scale);
                }
                break;
              }
            }
          });
        },
        function () {
          self._fireballs.forEach(function (fireball) {
            fireball.colouredFireballs.greenFireball.scale.set(1, 1);
            fireball.colouredFireballs.blueFireball.scale.set(1, 1);
            fireball.colouredFireballs.magentaFireball.scale.set(1, 1);
            fireball.colouredFireballs.redFireball.scale.set(1, 1);
          });
          --self._pulseCount;
          if (self._pulseCount > 0) {
            self.pulseWinningFireballs();
          }
        }
      );
    }

    returnToBaseGame() {
      this._elementsToFadeOut.forEach(function (element) {
        element.alpha = 0;
        element.visible = true;
      });

      gameController.potBonusWinnings = this._potBonusTask.data.winAmount;

      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          self._elementsToFadeOut.forEach(function (element) {
            element.alpha = progress;
          });
          self._fireballIntro.alpha = 1 - progress;
          self._winningsPanel.alpha = 1 - progress;
        },
        function () {
          self._elementsToFadeOut.forEach(function (element) {
            element.alpha = 1;
          });

          self._winningsPanel.alpha = 1;
          self._winningsPanel.visible = false;

          self._fireballIntro.alpha = 1;
          self._fireballIntro.visible = false;
          self._fireballIntro.reset();
          self.reset();

          resourceManager.getController("inputOverlord").setState("enabled");
          self._potBonusTask.leave();
        }
      );
    }

    reset() {
      this._fireballs.forEach(function (fireball) {
        fireball.fireball.alpha = 1;
        fireball.fireball.visible = true;
        fireball.colouredFireballs.greenFireball.visible = false;
        fireball.colouredFireballs.blueFireball.visible = false;
        fireball.colouredFireballs.magentaFireball.visible = false;
        fireball.colouredFireballs.redFireball.visible = false;
        fireball.texts.miniText.visible = false;
        fireball.texts.minorText.visible = false;
        fireball.texts.majorText.visible = false;
        fireball.texts.megaText.visible = false;
      });
    }

    recoverGame = function (task) {
      let clientParams = task.data.clientParams;
      this._isReplay = task.data.replay;

      this._recoveryChosenFireballs = [];

      if (
        clientParams &&
        clientParams.PotBonus &&
        clientParams.PotBonus.chosenFireballs &&
        clientParams.PotBonus.chosenFireballs.length > 0
      ) {
        this._recoveryHandle = task;
        this._recoveryHandle.join();
        this._recoveryChosenFireballs =
          clientParams.PotBonus.chosenFireballs.reverse();
      }
    };
  }

  var potBonusCreator = function (json) {
    return new PotBonus();
  };

  var potBonusInitialiser = function (json, potBonus) {};

  var potBonusFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "potBonus",
    potBonusCreator,
    potBonusInitialiser,
    potBonusFilesRequired
  );
})();
